import Vue from 'vue'
import Router from 'vue-router'
import Design from '@/pages/design/Design'
import Home from '@/pages/home/Home'
import Login from '@/pages/login/Login'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/design/:id',
      name: 'Design',
      component: Design,
      props: true
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js